import React, { Component } from 'react';
import Spinner from '../generics/Spinner';
import AddInventoryWidget from '../generics/AddInventoryWidget';

export default class  AddIngredient extends Component {
  render(){
    return(
      <div className="card">
        <div className="card-header card-header-inverse">
          <h4 className="mb-0">{this.props.title}</h4>
        </div>
        <div className="card-block">
          <h6>Scanning a label</h6>
          <AddInventoryWidget
            inputVal={this.props.ingredientBarCodeInput}
            onInputChange={this.props.onInventoryToAddChange}
            onSubmit={this.props.onInventoryAddSubmit}
            onScanItem={this.props.handleScannedInventory}
            onScanError={this.props.handleScanError}
            scanResult={this.props.scanResult}
            scanStatus={this.props.scanStatus}
          />
        {this.props.loadingIngredient ? <Spinner /> : null}
        </div>
      </div>
    );
  }
}
